export default function Attendance() {
    return (
        <svg
            className=" md:w-[300px] w-[250px] h-[270px]"
            width="350"
            height="350"
            viewBox="0 0 350 350"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M231.158 56.048C231.158 56.048 146.543 51.9605 77.678 98.8805C8.813 145.8 43.808 310.073 67.3355 320.445C90.863 330.818 181.335 348.803 251.123 318.27C320.91 287.738 343.853 177.203 333.795 145.455C323.738 113.708 304.223 65.0705 231.158 56.048Z"
                fill="#145DA0"
            />
            <path
                opacity="0.7"
                d="M231.158 56.048C231.158 56.048 146.543 51.9605 77.678 98.8805C8.813 145.8 43.808 310.073 67.3355 320.445C90.863 330.818 181.335 348.803 251.123 318.27C320.91 287.738 343.853 177.203 333.795 145.455C323.738 113.708 304.223 65.0705 231.158 56.048Z"
                fill="white"
            />
            <path
                d="M99.4105 231.795C99.4166 231.784 99.42 231.771 99.4206 231.758C99.4212 231.744 99.419 231.731 99.414 231.719C99.4089 231.707 99.4013 231.696 99.3917 231.687C99.382 231.678 99.3705 231.672 99.358 231.668C99.3461 231.663 99.3335 231.66 99.3207 231.66C99.3079 231.66 99.2952 231.663 99.2834 231.668C99.2715 231.672 99.2607 231.68 99.2517 231.689C99.2426 231.698 99.2354 231.708 99.2305 231.72C96.3779 238.543 94.1195 245.599 92.4805 252.81C90.8361 260.022 89.5992 267.321 88.7755 274.673L88.243 280.2C88.168 281.115 88.063 282.038 87.9955 282.96L87.8455 285.735C87.7705 287.588 87.658 289.433 87.6055 291.285L87.6505 296.835L87.7105 299.61C87.7555 300.54 87.823 301.463 87.883 302.385C88.0255 304.23 88.138 306.075 88.303 307.92C88.663 311.603 89.2105 315.263 89.803 318.908C89.8079 318.93 89.8201 318.951 89.8377 318.965C89.8554 318.98 89.8774 318.989 89.9005 318.99C89.9263 318.99 89.9511 318.98 89.9694 318.962C89.9877 318.943 89.998 318.919 89.998 318.893C89.998 317.04 89.908 315.203 89.8705 313.358C89.833 311.513 89.653 309.69 89.683 307.845C89.713 306 89.683 304.17 89.623 302.333L89.5705 299.58L89.623 296.828V291.323L89.773 285.825L89.8255 283.073C89.8255 282.158 89.9305 281.243 89.983 280.328L90.3205 274.83C90.9493 267.508 91.9884 260.226 93.433 253.02C94.8107 245.786 96.8106 238.685 99.4105 231.795Z"
                fill="#ABABAB"
            />
            <path
                d="M100.201 260.572C100.208 260.548 100.206 260.522 100.194 260.5C100.183 260.477 100.164 260.46 100.141 260.452C100.129 260.447 100.116 260.445 100.103 260.445C100.091 260.446 100.078 260.449 100.067 260.455C100.056 260.46 100.046 260.468 100.038 260.478C100.03 260.488 100.024 260.499 100.021 260.512C98.4576 265.099 97.1481 269.768 96.098 274.499C95.0615 279.242 94.2903 284.04 93.788 288.869C93.3005 293.684 92.7605 298.499 92.693 303.344C92.5733 308.19 92.7461 313.039 93.2105 317.864C93.2132 317.886 93.2226 317.906 93.2374 317.922C93.2522 317.939 93.2716 317.95 93.293 317.954C93.3197 317.956 93.3462 317.948 93.3672 317.931C93.3881 317.915 93.4018 317.891 93.4055 317.864C93.9605 313.042 94.3055 308.234 94.6355 303.427C94.9655 298.619 95.0255 293.804 95.3405 288.997C95.6437 284.198 96.2172 279.421 97.058 274.687C97.843 269.927 98.8921 265.215 100.201 260.572Z"
                fill="#ABABAB"
            />
            <path
                d="M116.152 270.699C116.134 270.682 116.11 270.672 116.085 270.672C116.06 270.672 116.036 270.682 116.017 270.699C112.028 273.263 108.435 276.396 105.352 279.999C103.803 281.812 102.408 283.751 101.182 285.797L100.327 287.417L99.6524 289.097C99.4272 289.653 99.232 290.222 99.0674 290.799C98.8949 291.369 98.7074 291.939 98.5499 292.517C97.3252 297.119 96.5862 301.837 96.3449 306.594C96.107 311.323 96.2826 316.063 96.8699 320.762C96.8733 320.783 96.884 320.804 96.9004 320.819C96.9168 320.834 96.9377 320.843 96.9599 320.844C96.9729 320.846 96.9862 320.846 96.999 320.842C97.0117 320.838 97.0235 320.832 97.0335 320.824C97.0435 320.815 97.0515 320.804 97.0569 320.792C97.0624 320.78 97.0651 320.767 97.0649 320.754L98.2799 306.729C98.7674 302.087 99.0674 297.422 100.057 292.892C100.185 292.329 100.35 291.782 100.492 291.219C100.624 290.66 100.787 290.11 100.98 289.569L101.55 287.942L102.3 286.442C103.409 284.405 104.689 282.465 106.125 280.644C108.969 276.923 112.342 273.638 116.137 270.894C116.15 270.895 116.163 270.893 116.175 270.889C116.187 270.885 116.199 270.879 116.209 270.871C116.218 270.862 116.226 270.852 116.232 270.841C116.238 270.829 116.241 270.817 116.242 270.804C116.243 270.791 116.242 270.778 116.238 270.766C116.234 270.754 116.228 270.743 116.219 270.733C116.211 270.723 116.201 270.715 116.189 270.709C116.178 270.704 116.165 270.7 116.152 270.699Z"
                fill="#ABABAB"
            />
            <path
                d="M108.435 288.749C106.26 290.152 104.805 292.357 103.583 294.577C102.416 296.851 101.505 299.249 100.868 301.724C100.673 302.332 100.523 302.954 100.388 303.577L99.9529 305.444C99.7186 306.684 99.5608 307.936 99.4804 309.194C99.4804 310.469 99.4279 311.737 99.4804 313.004C99.5781 314.263 99.7459 315.515 99.9829 316.754C99.9864 316.774 99.9952 316.792 100.009 316.806C100.022 316.821 100.039 316.832 100.058 316.837C100.071 316.84 100.085 316.841 100.099 316.838C100.112 316.836 100.125 316.83 100.136 316.823C100.148 316.815 100.157 316.805 100.164 316.793C100.172 316.781 100.176 316.768 100.178 316.754C100.472 315.518 100.697 314.266 100.853 313.004C101.048 311.767 101.235 310.544 101.385 309.314C101.535 308.084 101.73 306.869 101.82 305.639C101.91 304.409 102.083 303.179 102.353 301.979C102.78 299.55 103.477 297.175 104.43 294.899C105.291 292.58 106.687 290.496 108.503 288.817C108.517 288.799 108.524 288.776 108.524 288.753C108.524 288.73 108.517 288.708 108.503 288.689C108.488 288.693 108.473 288.701 108.462 288.711C108.45 288.722 108.441 288.735 108.435 288.749Z"
                fill="#ABABAB"
            />
            <path
                d="M86.0623 302.774C85.5373 296.541 84.5098 290.376 83.5348 284.219C82.5598 278.061 81.4873 271.904 80.3623 265.776C79.2373 259.649 77.9998 253.499 76.6573 247.439C76.6503 247.415 76.6353 247.395 76.6147 247.381C76.5941 247.367 76.5693 247.361 76.5448 247.364C76.5319 247.366 76.5195 247.37 76.5084 247.377C76.4972 247.383 76.4875 247.392 76.4798 247.403C76.4721 247.413 76.4666 247.425 76.4636 247.438C76.4606 247.45 76.4601 247.464 76.4623 247.476C77.5273 253.619 78.4948 259.776 79.4023 265.934C80.3098 272.091 81.2173 278.256 81.9973 284.436C82.7773 290.616 83.3548 296.811 84.1273 302.976L86.3773 321.516C86.3791 321.539 86.3895 321.56 86.4061 321.575C86.4228 321.591 86.4446 321.599 86.4673 321.599C86.4801 321.6 86.493 321.598 86.5052 321.594C86.5174 321.59 86.5287 321.584 86.5385 321.576C86.5482 321.567 86.5562 321.557 86.562 321.546C86.5678 321.534 86.5713 321.522 86.5723 321.509C86.6398 319.949 86.6398 318.381 86.6773 316.821C86.7148 315.261 86.6173 313.694 86.5873 312.134C86.5648 308.999 86.2948 305.886 86.0623 302.774Z"
                fill="#ABABAB"
            />
            <path
                d="M82.3264 302.685C81.9889 300.217 81.5764 297.765 81.0664 295.32L80.1964 291.682C79.9039 290.467 79.6339 289.252 79.2814 288.06C78.0376 283.231 76.446 278.499 74.5189 273.9L73.7689 272.182L72.9364 270.51C72.4114 269.377 71.7739 268.305 71.1664 267.21C69.9406 265.032 68.427 263.029 66.6664 261.255C66.658 261.247 66.6481 261.24 66.6371 261.235C66.6262 261.231 66.6145 261.229 66.6026 261.229C66.5908 261.229 66.579 261.231 66.5681 261.235C66.5572 261.24 66.5472 261.247 66.5389 261.255C66.5214 261.273 66.5117 261.297 66.5117 261.322C66.5117 261.348 66.5214 261.372 66.5389 261.39C68.176 263.226 69.5584 265.275 70.6489 267.48C71.1889 268.59 71.7589 269.677 72.2239 270.825L72.9739 272.52L73.6189 274.245C75.3446 278.86 76.7308 283.595 77.7664 288.412C78.3364 290.812 78.7114 293.25 79.1764 295.665L79.7614 299.317C79.9714 300.532 80.2339 301.74 80.3989 302.962C80.7889 305.392 81.2389 307.822 81.6664 310.26C82.0939 312.697 82.4914 315.142 83.0014 317.58C83.0063 317.603 83.0185 317.623 83.0361 317.638C83.0538 317.653 83.0758 317.661 83.0989 317.662C83.1247 317.662 83.1495 317.652 83.1678 317.634C83.1861 317.616 83.1964 317.591 83.1964 317.565C83.1964 315.075 83.1514 312.585 83.0239 310.102C82.8964 307.62 82.5814 305.16 82.3264 302.685Z"
                fill="#ABABAB"
            />
            <path
                d="M77.1747 303C76.0197 299.73 74.6847 296.535 73.2297 293.4C71.7555 290.27 70.0925 287.232 68.2497 284.303C68.2314 284.289 68.209 284.281 68.186 284.281C68.1629 284.281 68.1405 284.289 68.1222 284.303C68.1064 284.322 68.0977 284.346 68.0977 284.37C68.0977 284.395 68.1064 284.419 68.1222 284.438C69.7215 287.475 71.1366 290.606 72.3597 293.813C73.6197 297 74.7597 300.233 75.7197 303.518C76.6797 306.803 77.3847 310.14 78.2622 313.433C79.1397 316.725 79.9197 320.055 80.9322 323.385C80.9385 323.406 80.9513 323.425 80.9688 323.439C80.9863 323.452 81.0077 323.46 81.0297 323.46C81.0556 323.46 81.0804 323.45 81.0987 323.432C81.117 323.413 81.1272 323.389 81.1272 323.363C81.166 319.886 80.8417 316.415 80.1597 313.005C79.4342 309.596 78.436 306.25 77.1747 303Z"
                fill="#ABABAB"
            />
            <path
                d="M76.9563 313.883C76.329 311.85 75.4175 309.916 74.2488 308.138C73.1448 306.316 71.803 304.649 70.2588 303.181C69.4684 302.471 68.6177 301.831 67.7163 301.268C66.8176 300.698 65.836 300.27 64.8064 300.001C64.7844 299.993 64.7605 299.995 64.7396 300.005C64.7187 300.014 64.7023 300.032 64.6939 300.053C64.6878 300.065 64.6843 300.078 64.6837 300.091C64.6831 300.104 64.6854 300.117 64.6904 300.129C64.6954 300.141 64.703 300.152 64.7127 300.161C64.7223 300.17 64.7338 300.177 64.7463 300.181C66.5845 301.065 68.2132 302.33 69.5238 303.893C70.8527 305.415 71.9726 307.108 72.8538 308.926C73.7988 310.718 74.2863 312.676 75.1038 314.536C75.4713 315.481 75.8538 316.433 76.2513 317.378C76.604 318.363 77.0224 319.322 77.5038 320.251C77.5111 320.267 77.5227 320.28 77.5373 320.289C77.552 320.299 77.569 320.303 77.5863 320.303C77.5994 320.305 77.6127 320.305 77.6254 320.301C77.6381 320.298 77.6499 320.291 77.6599 320.283C77.6699 320.274 77.678 320.264 77.6834 320.252C77.6888 320.24 77.6915 320.226 77.6913 320.213C77.7266 319.149 77.6865 318.084 77.5713 317.026C77.4288 315.961 77.2038 314.918 76.9563 313.883Z"
                fill="#ABABAB"
            />
            <path
                d="M77.3394 256.356C77.3394 256.356 67.1394 254.001 64.7844 243.006C62.4294 232.011 70.0344 236.729 63.2094 219.456C56.3844 202.184 57.9594 198.261 60.3369 193.289C62.7144 188.316 63.9969 189.891 66.0894 196.431C68.1819 202.971 75.7719 213.179 78.6519 232.281C81.5319 251.384 77.3394 256.356 77.3394 256.356Z"
                fill="#145DA0"
            />
            <path
                d="M97.5003 237.75C97.5003 237.75 90.6978 235.395 90.4353 222.57C90.1728 209.745 95.4078 212.362 96.1953 196.402C96.9828 180.442 98.0253 169.185 100.905 168.922C103.785 168.66 111.368 176.775 113.985 194.572C116.603 212.37 110.588 224.137 105.353 229.372C100.118 234.607 97.5003 237.75 97.5003 237.75Z"
                fill="#145DA0"
            />
            <path
                d="M73.6801 271.792C73.6801 271.792 72.1126 262.372 69.0001 257.924C65.8876 253.477 59.0251 249.554 54.5776 240.914C50.1301 232.274 45.1576 228.097 45.4201 240.389C45.6826 252.682 51.1726 258.974 57.9826 263.159C64.7926 267.344 73.6801 271.792 73.6801 271.792Z"
                fill="#145DA0"
            />
            <path
                d="M70.7999 287.998C70.7999 287.998 64.4999 275.998 55.3649 267.081C46.2299 258.163 38.8649 253.738 41.4974 258.186C44.1299 262.633 47.2499 262.371 51.6974 270.223C56.1449 278.076 54.8399 283.828 61.1174 288.276C67.3949 292.723 70.7999 287.998 70.7999 287.998Z"
                fill="#145DA0"
            />
            <path
                d="M70.0199 303.457C69.7574 302.67 69.4949 296.917 60.5999 292.207C51.7049 287.497 43.3499 289.327 44.3699 291.682C45.3899 294.037 50.9174 297.96 56.3699 300.315C61.8224 302.67 70.0199 303.457 70.0199 303.457Z"
                fill="#145DA0"
            />
            <path
                d="M96.968 272.318C96.968 272.318 93.0455 267.346 95.138 256.883C97.2305 246.421 101.94 249.031 107.175 243.533C112.41 238.036 111.36 237.256 116.595 231.533C121.83 225.811 126.54 222.638 128.595 224.993C130.65 227.348 127.545 234.676 124.41 238.861C121.275 243.046 116.295 245.146 113.91 250.373C111.525 255.601 112.605 263.986 106.583 267.908C100.56 271.831 96.968 272.318 96.968 272.318Z"
                fill="#145DA0"
            />
            <path
                d="M110.055 275.197C110.055 275.197 119.475 264.464 126.277 256.619C133.08 248.774 135.697 242.752 135.96 247.979C136.222 253.207 138.315 257.399 132.817 264.209C127.32 271.019 110.055 275.197 110.055 275.197Z"
                fill="#145DA0"
            />
            <path
                d="M105.082 292.5C105.082 292.5 104.82 288.307 119.737 278.625C134.655 268.942 140.932 267.112 139.357 271.042C137.782 274.972 131.25 278.857 124.185 285.922C117.12 292.987 105.082 292.5 105.082 292.5Z"
                fill="#145DA0"
            />
            <path
                d="M77.9984 255.24C77.9984 255.24 74.5034 236.49 70.8359 223.125C67.1684 209.76 64.8359 201.668 64.8359 201.668"
                stroke="#ABABAB"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M96.8945 237.975C96.8945 237.975 103.255 217.627 105.347 205.327C107.44 193.027 105.085 183.87 104.035 178.38"
                stroke="#ABABAB"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M72.857 271.402C70.0392 266.556 66.8125 261.959 63.212 257.662C57.4595 250.86 53.012 247.2 50.3945 240.652"
                stroke="#ABABAB"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M96.9688 272.318C96.9688 272.318 99.0613 259.755 104.034 253.215C109.006 246.675 118.951 236.468 122.874 229.928"
                stroke="#ABABAB"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M69.4025 303.173C69.4025 303.173 60.5975 297.443 54.3125 294.301"
                stroke="#ABABAB"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M95.0128 358.672H83.4928C82.4956 358.672 81.5207 358.378 80.6906 357.825C79.8606 357.273 79.2124 356.487 78.8278 355.567C75.0778 346.567 65.0128 320.52 71.0653 313.14C76.8328 306.105 101.673 306.105 107.44 313.14C113.493 320.52 103.443 346.552 99.6778 355.567C99.2931 356.487 98.645 357.273 97.8149 357.825C96.9848 358.378 96.0099 358.672 95.0128 358.672Z"
                fill="#ABABAB"
            />
            <path
                d="M244.943 42.0003V275.61C244.945 277.138 244.647 278.651 244.065 280.063C243.482 281.475 242.627 282.759 241.548 283.84C240.469 284.921 239.187 285.779 237.776 286.364C236.365 286.949 234.853 287.25 233.325 287.25H132.383C130.853 287.253 129.339 286.954 127.926 286.37C126.513 285.786 125.229 284.929 124.148 283.847C123.067 282.766 122.21 281.481 121.627 280.068C121.044 278.654 120.746 277.139 120.75 275.61V42.0003C120.748 40.4735 121.047 38.9613 121.631 37.5504C122.215 36.1396 123.071 34.8577 124.151 33.7785C125.231 32.6992 126.513 31.8437 127.925 31.261C129.336 30.6783 130.848 30.3799 132.375 30.3828H175.703V30.5103C176.783 34.4028 179.273 36.9303 182.025 36.9303H183.608C186.368 36.9303 188.858 34.4028 189.93 30.5103L189.975 30.3828H233.325C234.851 30.3828 236.361 30.6833 237.771 31.2672C239.18 31.851 240.461 32.7067 241.54 33.7855C242.619 34.8643 243.474 36.145 244.058 37.5545C244.642 38.964 244.943 40.4747 244.943 42.0003Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M244.935 52.8603V42.0003C244.936 40.4751 244.636 38.9645 244.053 37.5551C243.47 36.1456 242.615 34.8649 241.537 33.786C240.459 32.7071 239.179 31.8512 237.77 31.2673C236.361 30.6834 234.85 30.3828 233.325 30.3828H190.013L189.968 30.5103C188.888 34.4028 186.405 36.9303 183.645 36.9303H182.063C179.31 36.9303 176.813 34.4028 175.74 30.5103V30.3828H132.375C130.848 30.3799 129.336 30.6783 127.925 31.261C126.513 31.8437 125.231 32.6992 124.151 33.7785C123.071 34.8577 122.215 36.1396 121.631 37.5504C121.047 38.9613 120.748 40.4735 120.75 42.0003V52.8753L244.935 52.8603Z"
                fill="#DBDBDB"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M120.75 273.787V275.61C120.746 277.139 121.044 278.653 121.627 280.067C122.21 281.481 123.067 282.765 124.148 283.847C125.229 284.928 126.513 285.785 127.926 286.369C129.339 286.953 130.853 287.253 132.383 287.25H233.325C236.404 287.25 239.357 286.026 241.535 283.849C243.712 281.672 244.935 278.719 244.935 275.64V273.817L120.75 273.787Z"
                fill="#DBDBDB"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M252.835 97.792V74.452H250.727V44.5795C250.727 39.6962 248.787 35.0129 245.334 31.5599C241.881 28.1069 237.198 26.167 232.315 26.167H133.405C128.521 26.167 123.838 28.1069 120.385 31.5599C116.932 35.0129 114.992 39.6962 114.992 44.5795V281.999C114.992 284.417 115.468 286.812 116.394 289.046C117.319 291.28 118.675 293.309 120.385 295.019C122.095 296.729 124.125 298.085 126.359 299.01C128.592 299.936 130.987 300.412 133.405 300.412H232.315C234.733 300.412 237.127 299.936 239.361 299.01C241.595 298.085 243.625 296.729 245.334 295.019C247.044 293.309 248.4 291.28 249.326 289.046C250.251 286.812 250.727 284.417 250.727 281.999V117.749H252.835V103.889H250.727V97.792H252.835ZM244.945 268.792C244.95 271.216 244.476 273.617 243.551 275.858C242.626 278.098 241.268 280.134 239.555 281.849C237.842 283.564 235.807 284.924 233.567 285.85C231.327 286.777 228.926 287.252 226.502 287.249H139.187C136.765 287.252 134.366 286.777 132.127 285.852C129.889 284.926 127.855 283.567 126.142 281.854C124.43 280.141 123.072 278.106 122.147 275.868C121.222 273.629 120.748 271.229 120.752 268.807V48.787C120.754 43.905 122.695 39.2236 126.148 35.7722C129.601 32.3208 134.283 30.382 139.165 30.382H175.682V30.5095C176.762 34.402 179.252 36.9295 182.005 36.9295H183.587C186.347 36.9295 188.837 34.402 189.91 30.5095L189.955 30.382H226.502C228.92 30.381 231.315 30.8563 233.549 31.7807C235.783 32.7051 237.814 34.0605 239.524 35.7696C241.234 37.4786 242.592 39.5079 243.518 41.7414C244.444 43.9749 244.921 46.369 244.922 48.787L244.945 268.792Z"
                fill="#145DA0"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M230.836 28.7021H134.881C132.546 28.7021 130.233 29.1628 128.076 30.0576C125.919 30.9525 123.959 32.264 122.31 33.9172C120.66 35.5703 119.353 37.5326 118.462 39.6917C117.572 41.8507 117.116 44.1642 117.121 46.4996V280.08C117.121 284.79 118.992 289.307 122.323 292.638C125.654 295.969 130.171 297.84 134.881 297.84H230.836C235.546 297.838 240.062 295.966 243.392 292.636C246.722 289.305 248.594 284.789 248.596 280.08V46.4996C248.6 44.1645 248.144 41.8515 247.253 39.6928C246.362 37.5342 245.055 35.5723 243.405 33.9194C241.756 32.2664 239.797 30.9549 237.64 30.0596C235.483 29.1644 233.171 28.7031 230.836 28.7021ZM244.944 269.452C244.948 271.788 244.491 274.102 243.6 276.261C242.709 278.42 241.401 280.382 239.75 282.035C238.1 283.688 236.14 285 233.982 285.894C231.825 286.789 229.512 287.25 227.176 287.25H138.534C136.197 287.253 133.883 286.794 131.723 285.901C129.564 285.008 127.602 283.698 125.95 282.045C124.298 280.393 122.989 278.43 122.097 276.271C121.204 274.111 120.747 271.796 120.751 269.46V48.1346C120.751 45.8015 121.211 43.4912 122.105 41.3359C122.998 39.1806 124.308 37.2225 125.959 35.5738C127.61 33.925 129.569 32.6178 131.726 31.727C133.882 30.8362 136.193 30.3792 138.526 30.3821H175.704V30.5096C176.784 34.4021 179.274 36.9296 182.026 36.9296H183.609C186.369 36.9296 188.859 34.4021 189.931 30.5096L189.976 30.3821H227.176C231.887 30.3821 236.405 32.253 239.737 35.5835C243.069 38.9139 244.942 43.4312 244.944 48.1422V269.452Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M184.207 31.2602C184.206 30.9178 184.103 30.5836 183.912 30.2997C183.72 30.0158 183.449 29.7949 183.132 29.6649C182.816 29.5349 182.468 29.5017 182.132 29.5694C181.797 29.6371 181.489 29.8027 181.247 30.0452C181.005 30.2878 180.841 30.5965 180.775 30.9324C180.709 31.2683 180.743 31.6162 180.875 31.9324C181.006 32.2485 181.228 32.5186 181.513 32.7087C181.798 32.8987 182.132 33.0002 182.475 33.0002C182.703 33.0012 182.929 32.9568 183.141 32.8696C183.352 32.7824 183.543 32.6542 183.705 32.4923C183.866 32.3304 183.993 32.1381 184.079 31.9266C184.166 31.7151 184.209 31.4886 184.207 31.2602Z"
                fill="white"
            />
            <path
                d="M131.813 37.8818C131.813 39.6368 129.848 40.2668 129.841 41.6318V41.7293H131.746V42.3143H129.203V41.8193C129.203 39.9443 131.161 39.5693 131.161 37.9493C131.161 37.3493 130.966 37.0343 130.486 37.0343C130.006 37.0343 129.803 37.3718 129.803 37.8893V38.3993H129.203V37.9268C129.203 37.0418 129.608 36.4268 130.501 36.4268C131.393 36.4268 131.813 36.9968 131.813 37.8818Z"
                fill="#263238"
            />
            <path
                d="M135 37.8749V38.0249C135.028 38.2734 134.975 38.5243 134.848 38.7396C134.72 38.9548 134.526 39.1226 134.295 39.2174C134.528 39.315 134.722 39.4855 134.849 39.7033C134.977 39.9211 135.029 40.1744 135 40.4249V40.8674C135 41.7524 134.588 42.3674 133.688 42.3674C132.787 42.3674 132.39 41.7824 132.39 40.8674V40.4999H132.998V40.9424C132.998 41.4599 133.207 41.7749 133.672 41.7749C134.137 41.7749 134.355 41.4674 134.355 40.8824V40.4324C134.355 39.8624 134.115 39.5924 133.605 39.5699H133.26V38.9999H133.643C133.743 39.0009 133.842 38.9802 133.934 38.9392C134.026 38.8982 134.107 38.8379 134.174 38.7625C134.24 38.687 134.289 38.5981 134.318 38.5019C134.346 38.4056 134.354 38.3043 134.34 38.2049V37.9424C134.34 37.3424 134.13 37.0349 133.658 37.0349C133.185 37.0349 132.982 37.3574 132.982 37.8824V38.1824H132.375V37.8749C132.375 36.9899 132.787 36.4199 133.672 36.4199C134.557 36.4199 135 36.9899 135 37.8749Z"
                fill="#263238"
            />
            <path
                d="M136.24 38.3174V39.1199H135.617V38.3174H136.24ZM136.24 41.4749V42.2774H135.617V41.4749H136.24Z"
                fill="#263238"
            />
            <path
                d="M137.55 38.8349C137.634 38.682 137.76 38.5559 137.912 38.471C138.065 38.3861 138.238 38.3459 138.413 38.3549C139.163 38.3549 139.485 38.9024 139.485 39.7349V40.8674C139.485 41.7524 139.065 42.3674 138.18 42.3674C137.295 42.3674 136.875 41.7824 136.875 40.8674V40.4999H137.482V40.9349C137.482 41.4524 137.7 41.7674 138.158 41.7674C138.615 41.7674 138.84 41.4524 138.84 40.9349V39.7499C138.84 39.2324 138.623 38.9174 138.158 38.9174C138.073 38.9133 137.989 38.9264 137.91 38.9559C137.831 38.9853 137.759 39.0305 137.698 39.0888C137.637 39.147 137.588 39.217 137.555 39.2945C137.522 39.3721 137.505 39.4555 137.505 39.5399V39.6674H136.897L137.055 36.4424H139.305V37.0274H137.603L137.55 38.8349Z"
                fill="#263238"
            />
            <path
                d="M142.71 37.8671V37.9721H142.11V37.8296C142.11 37.3046 141.893 36.9971 141.42 36.9971C140.948 36.9971 140.715 37.3121 140.715 37.9346V39.2321C140.783 39.0416 140.912 38.8784 141.081 38.7674C141.25 38.6565 141.451 38.6037 141.653 38.6171C142.403 38.6171 142.725 39.1496 142.725 39.9896V40.8671C142.725 41.7521 142.29 42.3671 141.405 42.3671C140.52 42.3671 140.07 41.7821 140.07 40.8671V37.9121C140.07 36.9896 140.483 36.4121 141.405 36.4121C142.328 36.4121 142.71 36.9821 142.71 37.8671ZM140.715 40.0421V40.9121C140.715 41.4296 140.933 41.7446 141.405 41.7446C141.878 41.7446 142.088 41.4296 142.088 40.9121V40.0421C142.088 39.5171 141.863 39.2021 141.405 39.2021C140.948 39.2021 140.715 39.5171 140.715 40.0421Z"
                fill="#263238"
            />
            <path d="M206.049 38.123H204.414V42.218H206.049V38.123Z" fill="#263238" />
            <path d="M208.229 37.3047H206.594V42.2172H208.229V37.3047Z" fill="#263238" />
            <path d="M210.42 36.7197H208.785V42.2172H210.42V36.7197Z" fill="#263238" />
            <path d="M212.604 35.707H210.969V42.217H212.604V35.707Z" fill="#263238" />
            <path
                d="M232.872 42.1045H223.047V36.1045H232.872V42.1045ZM223.594 41.557H232.324V36.6445H223.594V41.557Z"
                fill="#263238"
            />
            <path d="M229.604 37.2373H224.414V40.9648H229.604V37.2373Z" fill="#263238" />
            <path d="M233.777 38.3926H232.539V39.8101H233.777V38.3926Z" fill="#263238" />
            <path
                d="M219.441 40.7994C219.375 40.7999 219.31 40.7817 219.254 40.7469C217.251 39.5619 215.931 40.6644 215.879 40.7469C215.842 40.7789 215.8 40.8034 215.754 40.8191C215.708 40.8347 215.66 40.8411 215.611 40.838C215.563 40.8349 215.515 40.8222 215.472 40.8008C215.428 40.7794 215.389 40.7496 215.357 40.7132C215.325 40.6767 215.301 40.6343 215.285 40.5884C215.27 40.5425 215.263 40.494 215.266 40.4456C215.27 40.3972 215.282 40.3498 215.304 40.3063C215.325 40.2628 215.355 40.2239 215.391 40.1919C215.466 40.1319 217.154 38.6919 219.629 40.1919C219.697 40.2332 219.751 40.2959 219.781 40.3703C219.81 40.4448 219.815 40.5269 219.794 40.6043C219.773 40.6816 219.727 40.7499 219.663 40.7986C219.599 40.8474 219.521 40.874 219.441 40.8744V40.7994Z"
                fill="#263238"
            />
            <path
                d="M220.186 39.5614C220.121 39.5617 220.057 39.5463 219.999 39.5164C217.104 37.7914 215.161 39.4564 215.139 39.4714C215.07 39.5397 214.977 39.578 214.88 39.578C214.783 39.578 214.69 39.5397 214.621 39.4714C214.587 39.4379 214.559 39.3976 214.54 39.3532C214.521 39.3087 214.512 39.261 214.512 39.2127C214.512 39.1644 214.521 39.1166 214.54 39.0722C214.559 39.0277 214.587 38.9875 214.621 38.9539C214.621 38.9539 216.984 36.9214 220.336 38.9089C220.42 38.9602 220.481 39.0425 220.504 39.1378C220.528 39.2332 220.514 39.3342 220.464 39.4189C220.431 39.4616 220.389 39.4965 220.341 39.5211C220.293 39.5457 220.24 39.5595 220.186 39.5614Z"
                fill="#263238"
            />
            <path
                d="M220.855 38.1373C220.789 38.1377 220.724 38.1195 220.667 38.0848C217.007 35.9098 214.57 37.9573 214.472 38.0473C214.436 38.0793 214.394 38.1038 214.348 38.1194C214.302 38.1351 214.253 38.1415 214.205 38.1384C214.156 38.1352 214.109 38.1226 214.066 38.1012C214.022 38.0798 213.983 38.05 213.951 38.0135C213.919 37.9771 213.895 37.9347 213.879 37.8888C213.863 37.8429 213.857 37.7943 213.86 37.7459C213.863 37.6975 213.876 37.6502 213.897 37.6067C213.919 37.5632 213.949 37.5243 213.985 37.4923C213.985 37.4923 216.91 34.9948 221.042 37.4548C221.085 37.4788 221.121 37.511 221.151 37.5495C221.18 37.588 221.201 37.632 221.213 37.6789C221.225 37.7258 221.227 37.7747 221.22 37.8225C221.212 37.8703 221.196 37.9162 221.17 37.9573C221.138 38.012 221.091 38.0573 221.036 38.0889C220.981 38.1204 220.919 38.1371 220.855 38.1373Z"
                fill="#263238"
            />
            <path
                d="M218.341 41.415C218.343 41.5978 218.29 41.7769 218.189 41.9295C218.089 42.0822 217.945 42.2016 217.777 42.2726C217.608 42.3436 217.423 42.3629 217.243 42.3282C217.064 42.2934 216.899 42.2062 216.769 42.0775C216.639 41.9488 216.551 41.7844 216.514 41.6052C216.478 41.4261 216.496 41.2402 216.566 41.0712C216.635 40.9022 216.753 40.7577 216.905 40.656C217.057 40.5543 217.236 40.5 217.419 40.5C217.662 40.5 217.895 40.5962 218.068 40.7675C218.241 40.9389 218.339 41.1716 218.341 41.415Z"
                fill="#263238"
            />
            <path
                d="M223.867 181.808H142.455C140.247 181.808 138.457 183.597 138.457 185.805V214.118C138.457 216.325 140.247 218.115 142.455 218.115H223.867C226.075 218.115 227.865 216.325 227.865 214.118V185.805C227.865 183.597 226.075 181.808 223.867 181.808Z"
                fill="#145DA0"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M137.055 88.7773H229.267V161.572C229.267 163.335 228.567 165.025 227.321 166.271C226.075 167.517 224.385 168.217 222.622 168.217H143.7C141.937 168.217 140.247 167.517 139.001 166.271C137.755 165.025 137.055 163.335 137.055 161.572V88.7773Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M229.267 88.7773H137.055V95.6173H229.267V88.7773Z"
                fill="#145DA0"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M152.599 101.024H142.234V111.389H152.599V101.024Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M170.474 101.024H160.109V111.389H170.474V101.024Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M188.345 101.024H177.98V111.389H188.345V101.024Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M206.213 101.024H195.848V111.389H206.213V101.024Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M224.084 101.024H213.719V111.389H224.084V101.024Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M152.599 116.752H142.234V127.117H152.599V116.752Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M170.474 116.752H160.109V127.117H170.474V116.752Z"
                fill="#145DA0"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M188.345 116.752H177.98V127.117H188.345V116.752Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M206.213 116.752H195.848V127.117H206.213V116.752Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M224.084 116.752H213.719V127.117H224.084V116.752Z"
                fill="#145DA0"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M152.599 132.479H142.234V142.844H152.599V132.479Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M170.474 132.479H160.109V142.844H170.474V132.479Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M188.345 132.479H177.98V142.844H188.345V132.479Z"
                fill="#145DA0"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M206.213 132.479H195.848V142.844H206.213V132.479Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M224.084 132.479H213.719V142.844H224.084V132.479Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M152.599 148.199H142.234V158.564H152.599V148.199Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M170.474 148.199H160.109V158.564H170.474V148.199Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M188.345 148.199H177.98V158.564H188.345V148.199Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M206.213 148.199H195.848V158.564H206.213V148.199Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M224.084 148.199H213.719V158.564H224.084V148.199Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M135.555 241.904H232.267"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M136.82 248.01H157.693"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M136.82 251.07H157.693"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M136.82 254.123H157.693"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M136.82 257.176H157.693"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M161.258 248.01H182.13"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M161.258 251.07H182.13"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M161.258 254.123H182.13"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M161.258 257.176H182.13"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M185.691 248.01H206.564"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M185.691 251.07H206.564"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M185.691 254.123H206.564"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M185.691 257.176H206.564"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M210.129 248.01H231.001"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M210.129 251.07H231.001"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M210.129 254.123H231.001"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M210.129 257.176H231.001"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M143.707 76.2365V62.6465H144.997L148.86 71.6465V62.6465H150.435V76.2365H149.25L145.342 66.959V76.2365H143.707Z"
                fill="#263238"
            />
            <path
                d="M152.566 76.2365V62.6465H157.816V64.0565H154.501V68.5565H157.231V69.899H154.501V74.879H157.906V76.2365H152.566Z"
                fill="#263238"
            />
            <path
                d="M158.547 76.2365L161.382 69.1265L158.599 62.6465H160.362L162.424 67.4465L164.307 62.6465H166.062L163.212 69.2765L166.212 76.2365H164.449L162.237 71.1215L160.324 76.2365H158.547Z"
                fill="#263238"
            />
            <path
                d="M168.967 76.2365V64.0565H166.672V62.6465H173.099V64.0565H170.849V76.2365H168.967Z"
                fill="#263238"
            />
            <path
                d="M178.246 76.2365V62.6465H183.496V64.0565H180.129V68.5565H182.859V69.899H180.129V74.879H183.534V76.2365H178.246Z"
                fill="#263238"
            />
            <path
                d="M187.441 76.2365L184.441 62.6465H186.219L188.364 72.6665L190.411 62.6465H192.144L189.144 76.2365H187.441Z"
                fill="#263238"
            />
            <path
                d="M193.543 76.2365V62.6465H198.793V64.0565H195.425V68.5565H198.155V69.899H195.425V74.879H198.83V76.2365H193.543Z"
                fill="#263238"
            />
            <path
                d="M200.371 76.2365V62.6465H201.669L205.524 71.6465V62.6465H207.099V76.2365H205.891L201.984 66.959V76.2365H200.371Z"
                fill="#263238"
            />
            <path
                d="M210.747 76.2365V64.0565H208.422V62.6465H214.849V64.0565H212.599V76.2365H210.747Z"
                fill="#263238"
            />
            <path
                d="M219.361 76.3876C218.676 76.4146 217.998 76.2398 217.411 75.8851C216.888 75.5466 216.476 75.0614 216.226 74.4901C215.942 73.838 215.782 73.1385 215.754 72.4276L217.434 71.9776C217.466 72.4485 217.541 72.9154 217.659 73.3726C217.76 73.7788 217.958 74.1545 218.236 74.4676C218.384 74.6126 218.561 74.7255 218.754 74.7991C218.948 74.8727 219.155 74.9053 219.361 74.8951C219.566 74.9105 219.772 74.8817 219.965 74.8105C220.158 74.7393 220.333 74.6275 220.479 74.4826C220.748 74.1512 220.882 73.7308 220.854 73.3051C220.885 72.7722 220.737 72.2442 220.434 71.8051C220.123 71.3911 219.768 71.0115 219.376 70.6726L217.126 68.6551C216.711 68.3007 216.374 67.864 216.136 67.3726C215.911 66.8288 215.804 66.2434 215.821 65.6551C215.795 65.2306 215.857 64.8052 216.005 64.4062C216.152 64.0072 216.381 63.6432 216.676 63.3376C217.315 62.7727 218.151 62.4841 219.001 62.5351C219.482 62.5259 219.961 62.5969 220.419 62.7451C220.808 62.8697 221.159 63.0917 221.439 63.3901C221.732 63.7041 221.955 64.0775 222.091 64.4851C222.27 64.9855 222.381 65.5077 222.421 66.0376L220.809 66.4726C220.784 66.0567 220.716 65.6446 220.606 65.2426C220.525 64.8947 220.343 64.5788 220.081 64.3351C219.776 64.0906 219.392 63.9677 219.001 63.9901C218.801 63.9769 218.601 64.004 218.411 64.0697C218.222 64.1354 218.048 64.2384 217.899 64.3726C217.762 64.5218 217.658 64.697 217.591 64.8877C217.524 65.0785 217.496 65.2808 217.509 65.4826C217.495 65.837 217.567 66.1895 217.719 66.5101C217.89 66.8231 218.119 67.1006 218.394 67.3276L220.696 69.3451C221.205 69.8126 221.645 70.3505 222.001 70.9426C222.403 71.6067 222.606 72.3718 222.586 73.1476C222.602 73.7544 222.457 74.3545 222.166 74.8876C221.899 75.3626 221.501 75.7506 221.019 76.0051C220.505 76.2637 219.937 76.3949 219.361 76.3876Z"
                fill="#263238"
            />
            <path
                d="M164.879 197.527C164.281 197.565 163.688 197.404 163.191 197.069C162.79 196.761 162.498 196.333 162.359 195.847C162.197 195.289 162.118 194.71 162.126 194.129V190.499C162.114 189.888 162.192 189.279 162.359 188.692C162.491 188.21 162.785 187.789 163.191 187.499C163.696 187.185 164.285 187.036 164.879 187.072C165.403 187.049 165.922 187.174 166.379 187.432C166.754 187.666 167.04 188.02 167.189 188.437C167.365 188.945 167.449 189.481 167.436 190.019V190.829H166.079V190.079C166.083 189.743 166.065 189.408 166.026 189.074C166.004 188.817 165.893 188.575 165.711 188.392C165.47 188.212 165.17 188.129 164.871 188.159C164.555 188.129 164.238 188.221 163.986 188.414C163.784 188.615 163.657 188.88 163.626 189.164C163.565 189.528 163.537 189.897 163.544 190.267V194.324C163.529 194.733 163.572 195.142 163.671 195.539C163.722 195.797 163.87 196.025 164.084 196.177C164.322 196.317 164.595 196.384 164.871 196.372C165.02 196.385 165.171 196.368 165.314 196.323C165.456 196.278 165.589 196.205 165.704 196.109C165.88 195.91 165.99 195.661 166.019 195.397C166.06 195.046 166.081 194.693 166.079 194.339V193.589H167.436V194.339C167.443 194.895 167.365 195.449 167.204 195.982C167.081 196.425 166.818 196.818 166.454 197.099C165.986 197.401 165.435 197.551 164.879 197.527Z"
                fill="#263238"
            />
            <path
                d="M171.435 197.527C170.855 197.555 170.279 197.415 169.778 197.122C169.363 196.847 169.054 196.44 168.9 195.967C168.71 195.399 168.619 194.803 168.63 194.205V190.327C168.617 189.736 168.708 189.147 168.9 188.587C169.064 188.129 169.375 187.739 169.785 187.477C170.296 187.221 170.86 187.087 171.431 187.087C172.003 187.087 172.567 187.221 173.078 187.477C173.483 187.745 173.791 188.137 173.955 188.595C174.148 189.151 174.239 189.738 174.225 190.327V194.25C174.237 194.843 174.146 195.435 173.955 195.997C173.798 196.468 173.49 196.875 173.078 197.152C172.579 197.436 172.008 197.566 171.435 197.527ZM171.435 196.402C171.74 196.421 172.043 196.34 172.298 196.17C172.499 196 172.637 195.768 172.688 195.51C172.758 195.184 172.791 194.852 172.785 194.52V190.02C172.792 189.689 172.759 189.36 172.688 189.037C172.635 188.788 172.497 188.565 172.298 188.407C172.042 188.242 171.739 188.166 171.435 188.19C171.132 188.167 170.829 188.244 170.573 188.407C170.369 188.563 170.228 188.786 170.175 189.037C170.101 189.359 170.066 189.689 170.07 190.02V194.52C170.067 194.853 170.102 195.185 170.175 195.51C170.226 195.77 170.367 196.003 170.573 196.17C170.827 196.339 171.13 196.42 171.435 196.402Z"
                fill="#263238"
            />
            <path
                d="M175.629 197.415V187.178H176.604L179.514 193.973V187.178H180.699V197.415H179.791L176.844 190.425V197.415H175.629Z"
                fill="#263238"
            />
            <path
                d="M182.305 197.415V187.178H186.257V188.205H183.752V191.61H185.71V192.623H183.752V197.415H182.305Z"
                fill="#263238"
            />
            <path d="M187.32 197.415V187.178H188.723V197.415H187.32Z" fill="#263238" />
            <path
                d="M190.375 197.414V187.177H192.437C193.014 187.16 193.589 187.251 194.132 187.447C194.557 187.611 194.908 187.923 195.123 188.324C195.355 188.813 195.465 189.351 195.445 189.892C195.448 190.256 195.405 190.619 195.318 190.972C195.246 191.274 195.107 191.556 194.913 191.797C194.714 192.028 194.454 192.197 194.163 192.284L195.618 197.414H194.252L192.91 192.607H191.8V197.414H190.375ZM191.808 191.587H192.347C192.684 191.597 193.019 191.546 193.337 191.437C193.58 191.338 193.777 191.154 193.892 190.919C194.021 190.593 194.08 190.243 194.065 189.892C194.107 189.437 193.99 188.981 193.735 188.602C193.56 188.446 193.354 188.33 193.13 188.261C192.906 188.193 192.67 188.173 192.437 188.204H191.808V191.587Z"
                fill="#263238"
            />
            <path
                d="M196.906 197.415L197.101 187.178H198.504L200.304 195.48L202.126 187.178H203.514L203.709 197.415H202.554L202.441 189.983L200.709 197.415H199.906L198.181 189.983L198.069 197.415H196.906Z"
                fill="#263238"
            />
            <path
                d="M153.605 212.572L155.78 202.342H157.16L159.343 212.572H157.993L157.498 209.999H155.413L154.925 212.579L153.605 212.572ZM155.63 208.972H157.333L156.478 204.359L155.63 208.972Z"
                fill="#263238"
            />
            <path d="M161.1 212.572V203.399H159.367V202.342H164.25V203.399H162.525V212.572H161.1Z" fill="#263238" />
            <path
                d="M166.318 212.572V203.399H164.586V202.342H169.423V203.399H167.743V212.572H166.318Z"
                fill="#263238"
            />
            <path
                d="M170.414 212.572V202.342H174.382V203.399H171.839V206.789H173.902V207.794H171.839V211.544H174.404V212.564L170.414 212.572Z"
                fill="#263238"
            />
            <path
                d="M175.555 212.572V202.342H176.53L179.432 209.137V202.342H180.625V212.572H179.717L176.77 205.582V212.572H175.555Z"
                fill="#263238"
            />
            <path
                d="M182.25 212.572V202.342H184.5C185.119 202.313 185.736 202.431 186.3 202.687C186.733 202.909 187.071 203.279 187.252 203.73C187.449 204.298 187.533 204.899 187.5 205.5V209.25C187.514 209.872 187.418 210.492 187.215 211.08C187.042 211.549 186.717 211.948 186.292 212.212C185.765 212.492 185.171 212.624 184.575 212.595L182.25 212.572ZM183.675 211.552H184.5C184.895 211.59 185.29 211.481 185.61 211.245C185.846 211.008 185.987 210.693 186.007 210.36C186.057 209.894 186.079 209.426 186.075 208.957V205.635C186.084 205.203 186.051 204.771 185.978 204.345C185.958 204.197 185.908 204.054 185.832 203.925C185.756 203.796 185.655 203.684 185.535 203.595C185.206 203.421 184.834 203.343 184.462 203.37H183.712L183.675 211.552Z"
                fill="#263238"
            />
            <path
                d="M188.328 212.572L190.503 202.342H191.883L194.066 212.572H192.753L192.288 209.992H190.203L189.708 212.572H188.328ZM190.353 208.972H192.056L191.201 204.359L190.353 208.972Z"
                fill="#263238"
            />
            <path
                d="M195.098 212.572V202.342H196.073L198.983 209.137V202.342H200.168V212.572H199.26L196.313 205.582V212.572H195.098Z"
                fill="#263238"
            />
            <path
                d="M204.336 212.684C203.739 212.721 203.147 212.563 202.648 212.234C202.247 211.923 201.955 211.492 201.816 211.004C201.653 210.446 201.575 209.867 201.583 209.286V205.671C201.572 205.06 201.65 204.451 201.816 203.864C201.953 203.385 202.246 202.965 202.648 202.671C203.155 202.363 203.744 202.216 204.336 202.251C204.858 202.23 205.377 202.352 205.836 202.604C206.213 202.839 206.499 203.196 206.646 203.616C206.816 204.123 206.897 204.656 206.886 205.191V206.001H205.536V205.251C205.539 204.915 205.522 204.58 205.483 204.246C205.464 203.99 205.352 203.75 205.168 203.571C204.926 203.388 204.623 203.302 204.321 203.331C204.005 203.305 203.692 203.398 203.443 203.594C203.239 203.794 203.112 204.059 203.083 204.344C203.022 204.71 202.994 205.082 203.001 205.454V209.504C202.986 209.915 203.029 210.326 203.128 210.726C203.181 210.983 203.328 211.21 203.541 211.364C203.768 211.495 204.028 211.56 204.291 211.551C204.593 211.581 204.896 211.489 205.131 211.296C205.307 211.097 205.417 210.848 205.446 210.584C205.487 210.23 205.507 209.874 205.506 209.519V208.769H206.856V209.519C206.865 210.077 206.789 210.633 206.631 211.169C206.508 211.61 206.245 212 205.881 212.279C205.42 212.57 204.88 212.712 204.336 212.684Z"
                fill="#263238"
            />
            <path
                d="M208.273 212.572V202.342H212.248V203.399H209.713V206.789H211.768V207.794H209.713V211.544H212.248V212.564L208.273 212.572Z"
                fill="#263238"
            />
            <path
                d="M278.999 347.43C278.999 347.43 275.669 352.012 274.214 352.635C272.759 353.257 270.044 353.677 269.211 355.552C268.753 356.461 268.47 357.448 268.379 358.462H288.996C288.996 358.462 289.829 355.755 288.996 354.09C288.479 353.04 288.127 351.917 287.954 350.76L278.999 347.43Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M289.38 356.385H268.913C268.638 357.047 268.469 357.748 268.41 358.462H289.028C289.216 357.784 289.334 357.088 289.38 356.385Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M301.102 352.013L301.514 358.673H311.512C311.744 357.424 311.672 356.138 311.302 354.923C310.679 353.048 310.049 351.383 310.049 351.383L301.102 352.013Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M301.498 358.673H311.495C311.648 357.849 311.671 357.007 311.563 356.176H301.355L301.498 358.673Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M270.906 250.402C270.906 250.402 272.579 272.055 272.999 279.75C273.419 287.445 278.999 347.43 278.999 347.43C278.999 347.43 287.121 352.425 288.156 352.425C289.191 352.425 290.451 280.17 290.451 280.17L301.071 352.012C302.215 352.38 303.403 352.59 304.604 352.635C306.276 352.635 310.019 351.382 310.019 351.382L306.509 264.75V250.402C306.509 250.402 285.509 253.312 279.861 252.48C276.817 252.073 273.819 251.377 270.906 250.402Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M296.308 263.52L291.725 267.052L290.48 280.17"
                stroke="#808080"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M298.202 162.428C298.202 162.428 289.705 161.363 287.252 164.251C284.8 167.138 284.252 172.786 282.512 174.128C280.772 175.471 279.82 173.806 279.047 175.561C278.275 177.316 279.535 179.483 279.535 179.483C279.535 179.483 279.325 187.928 280.285 188.341C281.245 188.753 285.535 188.753 285.535 188.753L284.837 192.218L295.577 192.668L296.515 189.038C296.515 189.038 304.682 184.306 306.887 180.713C309.092 177.121 308.567 169.156 306.362 166.381C304.157 163.606 298.202 162.428 298.202 162.428Z"
                fill="#B2B2B2"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M285.045 173.73C284.782 174.36 284.355 174.795 284.1 174.69C283.845 174.585 283.86 173.978 284.1 173.34C284.34 172.703 284.782 172.275 285.037 172.38C285.292 172.485 285.307 173.093 285.045 173.73Z"
                fill="#263238"
            />
            <path
                d="M280.352 180.848C280.798 181.076 281.315 181.126 281.798 180.987C282.28 180.847 282.691 180.529 282.947 180.098"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M285.133 170.768C285.133 170.768 286.22 170.175 286.348 171.983"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M306.323 166.388C304.118 163.613 298.2 162.428 298.2 162.428C298.2 162.428 289.703 161.363 287.25 164.251C287.25 164.251 291.945 163.066 291.338 165.068C290.73 167.071 285.863 170.131 287.535 171.316C289.208 172.501 291.09 171.601 290.31 173.356C289.53 175.111 288.555 176.828 289.373 176.993C290.19 177.158 292.478 175.276 293.453 175.688C294.428 176.101 295.538 179.078 294.6 180.586C293.97 181.514 293.001 182.158 291.9 182.378C291.9 182.378 293.573 186.751 295.043 187.898C295.681 188.4 296.484 188.644 297.293 188.581C299.37 187.313 305.115 183.638 306.908 180.713C309.053 177.128 308.528 169.163 306.323 166.388Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M269.934 250.837L270.534 255.615C270.534 255.615 273.534 258.802 282.084 259.005C290.634 259.207 301.209 258.21 303.796 257.415C306.384 256.62 306.984 255.817 306.984 255.817L306.511 250.402C306.511 250.402 290.851 255.817 269.934 250.837Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M308.318 262.627C308.318 262.627 307.673 265.064 307.523 265.792C307.373 266.519 307.816 271.792 307.816 272.542C307.816 273.292 308.566 274.042 309.136 273.419C309.136 273.419 309.886 276.067 310.756 275.917C311.626 275.767 314.423 272.692 315.008 270.044C315.593 267.397 314.866 263.144 314.866 263.144L308.318 262.627Z"
                fill="#B2B2B2"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M309.43 266.385C309.592 267.103 309.95 267.763 310.465 268.29L311.215 268.882L311.657 271.522C311.657 271.522 311.365 273.135 311.215 274.02"
                fill="#B2B2B2"
            />
            <path
                d="M309.43 266.385C309.592 267.103 309.95 267.763 310.465 268.29L311.215 268.882L311.657 271.522C311.657 271.522 311.365 273.135 311.215 274.02"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M309.133 273.427L309.283 269.609"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M308.309 259.357C308.309 259.357 308.347 261.525 308.309 262.627C308.272 263.73 310.477 265.537 313.267 264.832C316.057 264.127 316.109 258.652 316.109 258.652C316.109 258.652 312.262 261.495 308.309 259.357Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M306.855 198.36C306.855 198.36 312.908 202.313 314.535 205.335C316.163 208.358 320.123 236.753 320.588 239.775C321.053 242.798 316.838 258.623 316.163 260.715C315.488 262.808 311.715 262.433 310.35 261.878C309.568 261.537 308.893 260.989 308.4 260.292C307.907 259.595 307.614 258.777 307.553 257.925L306.855 243.968V198.36Z"
                fill="#145DA0"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M309.576 232.32C309.861 222.023 310.408 212.378 310.581 210.69C310.776 208.703 310.581 203.438 309.246 200.25C307.356 198.38 305.188 196.814 302.818 195.608C302.047 195.37 301.264 195.175 300.471 195.023L301.131 194.813C299.972 194.311 298.779 193.893 297.561 193.56C294.433 192.728 286.108 192.315 283.611 194.603C283.611 194.603 276.396 196.853 272.848 199.44C271.061 201.671 269.942 204.362 269.623 207.203C269.158 212.318 267.786 242.49 267.786 242.49C267.786 242.49 266.121 247.485 268.206 249.99C270.291 252.495 274.656 256.238 287.353 255.818C300.051 255.398 306.103 253.725 307.813 252.15C308.301 251.532 308.649 250.816 308.833 250.05C309.444 248.08 309.73 246.023 309.681 243.96C309.613 240 309.501 232.365 309.576 232.32Z"
                fill="#145DA0"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M281.316 195.435C282.204 194.187 283.179 193.004 284.234 191.895C284.856 191.482 293.811 189.397 296.519 190.23C299.226 191.062 300.471 195.022 300.471 195.022C294.097 194.286 287.653 194.425 281.316 195.435Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M231.413 204.938C231.413 204.938 230.138 202.088 229.38 200.573C228.623 199.058 222.945 194.768 221.805 193.381C220.665 191.993 219.278 192.631 219.158 193.883C219.038 195.136 220.29 196.538 220.658 197.041C221.025 197.543 221.918 198.811 221.918 198.811C221.918 198.811 218.633 200.956 218.385 201.586C218.138 202.216 218.888 204.743 219.135 205.628C219.383 206.513 219.765 207.391 220.395 207.391H221.025C221.025 207.391 222.165 208.276 222.923 208.786C223.68 209.296 226.275 209.258 226.275 209.258L228.098 210.301C228.098 210.301 229.02 206.648 231.413 204.938Z"
                fill="#B2B2B2"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M221.045 207.391C220.72 206.635 220.549 205.821 220.543 204.998L221.045 207.391Z" fill="white" />
            <path
                d="M221.045 207.391C220.72 206.635 220.549 205.821 220.543 204.998"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M235.039 206.686C235.039 206.686 232.616 205.561 231.409 204.938C230.201 204.316 227.014 205.778 226.294 209.258C225.574 212.738 231.619 215.738 231.619 215.738C231.619 215.738 230.539 209.926 235.039 206.686Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M281.316 195.436C281.316 195.436 270.066 199.523 268.693 200.453C267.321 201.383 254.038 216.953 254.038 216.953C254.038 216.953 238.288 208.028 236.196 206.866C234.103 205.703 230.533 206.011 229.603 209.506C228.673 213.001 229.371 215.791 232.161 217.883C234.951 219.976 252.636 232.073 255.201 233.003C257.766 233.933 264.276 229.253 264.276 229.253L276.373 218.551"
                fill="#145DA0"
            />
            <path
                d="M281.316 195.436C281.316 195.436 270.066 199.523 268.693 200.453C267.321 201.383 254.038 216.953 254.038 216.953C254.038 216.953 238.288 208.028 236.196 206.866C234.103 205.703 230.533 206.011 229.603 209.506C228.673 213.001 229.371 215.791 232.161 217.883C234.951 219.976 252.636 232.073 255.201 233.003C257.766 233.933 264.276 229.253 264.276 229.253L276.373 218.551"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M231.086 358.672H348.056"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M25.832 358.672H225.617"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M314.318 66.5479L274.133 76.6503L288.6 84.4503L314.318 66.5479Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M288.598 84.4503L289.828 95.6478L314.315 66.5479L288.598 84.4503Z"
                fill="#B2B2B2"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M293.001 86.6403L289.828 95.6478L314.316 66.5479L293.001 86.6403Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M314.315 66.5479L293 86.6403L305.195 94.8453L314.315 66.5479Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M113.66 126.893L112.348 127.643"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M109.725 129.105C96.1497 136.875 78.9746 147.9 62.8646 161.663C20.6321 197.783 64.1922 223.703 127.117 197.115C189 171 243.135 142.695 283.267 100.058"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeDasharray="3.02 3.02"
            />
            <path
                d="M284.301 98.9475L285.313 97.8525"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M228.883 87.8321C253.385 77.9996 291.748 49.5446 297.748 40.8446C326.248 -0.637886 253.565 39.4346 253.565 39.4346"
                stroke="#263238"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeDasharray="3 3"
            />
        </svg>
    );
}
